// Issue with watermelonDB library https://github.com/Nozbe/WatermelonDB/issues/629
// @ts-nocheck
import { Model, Q } from '@nozbe/watermelondb';
import {
    field,
    date,
    readonly,
    lazy,
    children,
} from '@nozbe/watermelondb/decorators';
import { setGenerator } from '@nozbe/watermelondb/utils/common/randomId';
import { v4 as uuidv4 } from 'uuid';
import { ProductType } from '../../types/Products';

setGenerator(uuidv4);

export default class EntryProduct extends Model {
    static table = 'entry_products';

    static associations = {
        entries: { type: 'belongs_to', key: 'entry_id' },
        products: { type: 'belongs_to', key: 'product_id' },
    };

    @field('entry_id') entryId;
    @field('product_id') productId;
    @field('quantity') quantity;
    @field('user_id') userId;
    @field('organisation_id') organisationId;
    @date('created_at') createdAt;
    @date('updated_at') updatedAt;

    @lazy
    product = this.collections
        .get('products')
        .query(Q.where('id', this.productId));
}

export type EntryProductSimple = {
    id: string;
    entryId: string;
    productId: string;
    quantity: number;
    userId: string;
    organisationId: string;
    createdAt: string;
    updatedAt: string;
    // joined from products table by attachRelations
    name?: string;
    productType?: ProductType;
    brand?: string | null;
    family?: string | null;
    material?: string | null;
    shape?: string | null;
    clips?: string | null;
    shoeSize?: string | null;
    nailSize?: string | null;
    productSize?: string | null;
    dimensions?: string | null;
};

export const simplifyEntryProduct = (
    entryProduct: EntryProductModel,
): EntryProductSimple => {
    return {
        id: entryProduct.id,
        entryId: entryProduct.entryId,
        productId: entryProduct.productId,
        quantity: entryProduct.quantity,
        userId: entryProduct.userId,
        organisationId: entryProduct.organisationId,
        createdAt: entryProduct.createdAt.toISOString(),
        updatedAt: entryProduct.updatedAt.toISOString(),
    };
};
